// This file defines exports from the builtin `Array` constructor for internal
// use only.
/**
 * @internal
 */
const Builtin = Array;
export { Builtin as Array };
//# sourceMappingURL=builtin.js.map